import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3af0adec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "key_control_page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line" })
], -1))
const _hoisted_3 = { class: "body" }
const _hoisted_4 = { class: "top_btns" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn_x_big" }, "Back", -1))
const _hoisted_6 = { class: "medis_btns" }
const _hoisted_7 = { class: "flex_center" }
const _hoisted_8 = { class: "btn_circle flex_center" }
const _hoisted_9 = { class: "flex_between" }
const _hoisted_10 = { class: "btn_circle flex_center" }
const _hoisted_11 = { class: "btn_circle flex_center" }
const _hoisted_12 = { class: "btn_circle flex_center" }
const _hoisted_13 = { class: "flex_between" }
const _hoisted_14 = { class: "btn_circle flex_center" }
const _hoisted_15 = { class: "btn_circle flex_center" }
const _hoisted_16 = { class: "btn_circle flex_center" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<div class=\"color_btns flex_between\" data-v-3af0adec><span class=\"btn_color red\" data-v-3af0adec></span><span class=\"btn_color purple\" data-v-3af0adec></span><span class=\"btn_color yellow\" data-v-3af0adec></span><span class=\"btn_color blue\" data-v-3af0adec></span></div>", 1)
const _hoisted_18 = { class: "direction_btns flex_between" }
const _hoisted_19 = { class: "left flex_center" }
const _hoisted_20 = { class: "center flex_between flex_direction_column" }
const _hoisted_21 = { class: "center_btn flex_cneter" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "center_btn" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ok" }, "OK")
], -1))
const _hoisted_23 = { class: "center_btn" }
const _hoisted_24 = { class: "right flex_center" }
const _hoisted_25 = { class: "num_btns flex_between" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined")!
  const _component_StepBackwardOutlined = _resolveComponent("StepBackwardOutlined")!
  const _component_PauseOutlined = _resolveComponent("PauseOutlined")!
  const _component_StepForwardOutlined = _resolveComponent("StepForwardOutlined")!
  const _component_FastBackwardOutlined = _resolveComponent("FastBackwardOutlined")!
  const _component_Record = _resolveComponent("Record")!
  const _component_FastForwardOutlined = _resolveComponent("FastForwardOutlined")!
  const _component_LeftOutlined = _resolveComponent("LeftOutlined")!
  const _component_UpOutlined = _resolveComponent("UpOutlined")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_RollbackOutlined = _resolveComponent("RollbackOutlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", {
          class: "btn_x_big map_keys",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.clickMapKey && $setup.clickMapKey(...args)))
        }, "Mapping Keys")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_CaretRightOutlined)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_StepBackwardOutlined)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_PauseOutlined)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_StepForwardOutlined)
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_FastBackwardOutlined)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Record)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_FastForwardOutlined)
          ])
        ])
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_LeftOutlined)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_UpOutlined)
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createVNode(_component_DownOutlined)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createVNode(_component_RightOutlined, { class: "scale8" })
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.numsBtn, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "flex_center btn_circle numsBtn",
            key: item
          }, [
            (item === 'BACK')
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                  _createVNode(_component_RollbackOutlined, { style: {"font-size":"0.1rem"} })
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(item), 1))
          ]))
        }), 128))
      ])
    ])
  ]))
}